export default __webpack_public_path__ + "static/media/avatar_tapir7.d5d2b15c.mp3";